import { createRoute } from '@tanstack/react-router'

import { appRoute } from '@/app'

import { CreateOrganization } from './CreateOrganization'

export const createOrganizationRoute = createRoute({
    getParentRoute: () => appRoute,
    path: '/create-organization',
    component: CreateOrganization,
})
